import { get_api_url } from '../../../../utils/urls';
import { api_with_method } from '../../../../redux/api_funcs';

export interface PredefinedTemplate {
  id: number;
  tag: string;
  sms_body: string;
}

export interface PredefinedTemplatesResponse {
  data: PredefinedTemplate[];
  status: 'success' | 'error';
}

export async function fetchPredefinedWhatsAppTemplates(
  student_uuid: string
): Promise<PredefinedTemplate[]> {
  const apiUrl = get_api_url(
    `/v2/cms_user/get_student_predefined_whatsapp_templates/${student_uuid}`,
    null,
    true
  );

  const response = await api_with_method('get', apiUrl, null, true);

  if (response.data.status === 'success') {
    return response.data.data;
  } else {
    throw new Error('Failed to fetch templates');
  }
}
